export default __webpack_public_path__ + "static/media/leading page graphics.6bc149e9.png";